// eslint-disable-next-line import/no-anonymous-default-export
export default {
  spacing: (factor: number) => `${0.25 * factor}rem`,
};
